import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { DashboardLayout } from './layouts/DashboardLayout';
import { GamesList } from './pages/Games/GamesList';
import { CreateGame } from './pages/Games/CreateGame';
import { EditGame } from './pages/Games/EditGame';
import { AdjustConfig } from './pages/AdjustConfig/AdjustConfig';
import { ProtectedRoute } from './routes/ProtectedRoute';
import { Login } from './pages/Auth/Login';
import { Analytics } from './pages/Analytics/Analytics';
import { Users } from './pages/Users/Users';
import { RequireRole } from './routes/RequireRole';
import { USER_ROLES } from './utils/constants';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<DashboardLayout />}>
              <Route index element={<Navigate to="/games" replace />} />
              <Route path="games" element={<GamesList />} />
              <Route path="games/create" element={<CreateGame />} />
              <Route path="games/:gameId/edit" element={<EditGame />} />
              <Route path="adjust-config/:gameId" element={<AdjustConfig />} />
              <Route path="analytics" element={<Analytics />} />
              <Route element={<RequireRole roles={[USER_ROLES.SUPER_ADMIN]} />}>
                <Route path="users" element={<Users />} />
              </Route>
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
          },
          success: {
            style: {
              background: '#10b981',
            },
          },
          error: {
            style: {
              background: '#ef4444',
            },
          },
        }}
      />
    </QueryClientProvider>
  );
}

export default App;